
import { loadRecaptchaScript, renderV2, resetV2 } from "@/assets/utils/recaptchaHelper";
import { defineComponent } from "vue";

export default defineComponent({
  name: "RecaptchaV2Widget",

  props: {
    siteKey: {
      type: String,
      default: () =>
        process.env.VUE_APP_RecaptchaEnterprise_CheckboxSiteKey || process.env.VUE_APP_RecaptchaV2_SiteKey || "",
    },
    v3SiteKey: {
      type: String,
      default: () =>
        process.env.VUE_APP_RecaptchaEnterprise_ScoreSiteKey || process.env.VUE_APP_RecaptchaV3_SiteKey || "",
    },
  },

  emits: ["verify", "expired", "error"],

  data() {
    return {
      widgetId: null as number | null,
    };
  },

  async mounted(): Promise<void> {
    try {
      await loadRecaptchaScript(this.v3SiteKey || "", "en");
      const container = this.$refs.recaptchaContainer as HTMLElement;
      this.widgetId = renderV2(container, this.siteKey || "", {
        onVerify: (token: string) => this.$emit("verify", token),
        onExpired: () => this.$emit("expired"),
        onError: () => this.$emit("error"),
        action: "login",
      });
    } catch {
      this.$emit("error");
    }
  },

  methods: {
    reset(): void {
      if (this.widgetId !== null) {
        resetV2(this.widgetId);
      }
    },
  },
});
